export default {
  nationalLicense: {
    revoke: "v1/revoke-license",
    list: "v1/national-license",
    suspend: "v1/suspend-license",
    unsuspend: "v1/unsuspend-license",
    refute: "v1/refute-request",
    confirmDocument: "v1/confirm-document",
    termMapping: "v1/term-mapping",
    termMappingCode: "v1/term-mapping/{0}",
  },
};
